import { BASEURL } from '@services/network';

export function getGPTRecordUrl(id) {
  return `${BASEURL}/cartographer/admin/gpt_records/${id}`;
}
